<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div [nbSpinner]="loading" style="display: flex">
    <input type="text" (click)="openChooseCatalogModal()" nbInput readonly fullWidth [disabled]="loading" [placeholder]="props.label" [value]="getOptionLabel(catalog)" [id]="id"/>
    <button nbButton status="control" [disabled]="loading" (click)="openChooseCatalogModal()" type="button">
      <nb-icon icon="list-outline"></nb-icon>
    </button>
    <button nbButton status="control" (click)="select(null)" *ngIf="catalog?.id > 1" type="button">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
